import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ActsOfAdvocacyIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M15.42,8.81l1.5,2.59a.92.92,0,0,1-.22,1.28L16,13.1a.83.83,0,0,1-.9-.09,1.25,1.25,0,0,1-.32-.36l-1.5-2.59a1.45,1.45,0,0,1-.15-.46.82.82,0,0,1,.38-.82l.72-.42A.91.91,0,0,1,15.42,8.81Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.43,10.35h.22a0,0,0,0,1,0,0v3a0,0,0,0,1,0,0h-.22a.78.78,0,0,1-.78-.78V11.13a.78.78,0,0,1,.78-.78Z",
    transform: "translate(-4.16 8.16) rotate(-30)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.59,13.12h1.5a0,0,0,0,1,0,0v2.41a.59.59,0,0,1-.59.59h-.33a.58.58,0,0,1-.58-.58V13.12a0,0,0,0,1,0,0Z",
    transform: "translate(-4.99 10.63) rotate(-30)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19,5l3,5.22a8.93,8.93,0,0,0-5.08,1.18l-1.5-2.59A9,9,0,0,0,19,5Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "8.12",
    cy: "8.11",
    r: "3.11"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.17,12.78A6.22,6.22,0,0,0,2,18.12a.78.78,0,0,0,.77.88H13.56a.78.78,0,0,0,.77-.88A6.23,6.23,0,0,0,8.17,12.78Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "14.84",
    y: "13.12",
    width: "5",
    height: "3",
    rx: "1.5",
    transform: "translate(-4.99 10.63) rotate(-30)"
  })]
}), 'ActsOfAdvocacyIcon');